module.exports = "<app-header></app-header>\n<main class=\"container\">\n\t<router-outlet></router-outlet>\n</main>"


//////////////////
// WEBPACK FOOTER
// F:/Projects/anoki/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main